module.exports = {
  appMobileInstallation: {
    hide: 'Ausblenden',
    slug_title: 'Deine App-ID',
    title: 'Hol dir jetzt die Keelearning App!',
  },
}
